import { useEffect } from 'react';

export enum KK_UTM_KSOURCE {
  ITViOSAddUnit = 'itvxAppiOS',
  ITVAndroidAddUnit = 'itvxAppiOS',
  ITVTVAd = 'itvxTV',
  ITVVanityUrl = 'itvxShortUrl',
  ITVLP = 'itvxLP',
}

export const usePluginActivationUTMQueryParamExtraction = (
  query: URLSearchParams
) => {
  useEffect(() => {
    const utmKSource = query.get('ksource') as KK_UTM_KSOURCE;
    handleKSourceUTMParameter(utmKSource);
  }, []);

  const handleKSourceUTMParameter = (Ksource: KK_UTM_KSOURCE) => {
    if (
      Ksource === KK_UTM_KSOURCE.ITVAndroidAddUnit ||
      Ksource === KK_UTM_KSOURCE.ITVLP
    ) {
      location.href = '';
    }
  };
};
